<template>
  <!-- AI-Generated Begin -->
  <div class="redirect-container">
    <!-- Loading -->
    <div v-if="loading" class="loading">
      <div class="loading-spinner"></div>
      <p>{{ $store.state.isEn ? 'Loading...' : '正在跳转...' }}</p>
    </div>
    
    <!-- Error / Timeout -->
    <div v-else class="error">
      <div class="error-icon">⚠️</div>
      <p class="error-title">{{ errorTitle }}</p>
      <p class="error-desc">请重新扫描二维码打开</p>
      <button class="retry-btn" @click="redirectToPdf">重新加载</button>
    </div>
  </div>
  <!-- AI-Generated End -->
</template>

<script>
// AI-Generated Begin
export default {
  name: 'PdfRedirect',
  data() {
    return {
      loading: true,
      error: false,
      timeout: false,
      fixedId: this.$route.query.id || 1,
      timeoutTimer: null
    };
  },
  computed: {
    errorTitle: function() {
      if (this.timeout) return '加载超时';
      if (this.error) return '加载失败';
      return '未知错误';
    }
  },
  mounted: function() {
    this.redirectToPdf();
  },
  beforeDestroy: function() {
    // 清理定时器
    if (this.timeoutTimer) {
      clearTimeout(this.timeoutTimer);
    }
  },
  methods: {
    redirectToPdf: function() {
      var _this = this;
      this.loading = true;
      this.error = false;
      this.timeout = false;
      
      // 设置5秒超时
      this.timeoutTimer = setTimeout(function() {
        _this.timeout = true;
        _this.loading = false;
      }, 5000);
      
      this.$api.get('/digital/list', { 
        current: 1, 
        pageSize: 1, 
        id: this.fixedId 
      }, function(response) {
        // 清除超时定时器
        clearTimeout(_this.timeoutTimer);
        
        if (response.code === 0 && response.data && response.data.length > 0) {
          var pdfUrl = response.data[0].fileUrl;
          if (pdfUrl) {
            // 模拟302跳转
            window.location.replace(pdfUrl);
            return;
          }
        }
        
        // 数据异常
        _this.error = true;
        _this.loading = false;
      }, function(err) {
        clearTimeout(_this.timeoutTimer);
        console.error('获取PDF失败:', err);
        _this.error = true;
        _this.loading = false;
      });
    }
  }
};
// AI-Generated End
</script>

<style scoped>
/* AI-Generated Begin */
.redirect-container {
  min-height: 100vh;
  background: #faf8f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e8e0d5;
  border-top-color: #ca9d76;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading p {
  margin-top: 16px;
  color: #666;
  font-size: 14px;
}

.error {
  text-align: center;
  padding: 40px 20px;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.error-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 8px;
}

.error-desc {
  font-size: 14px;
  color: #999;
  margin-bottom: 24px;
}

.retry-btn {
  padding: 12px 32px;
  background: #ca9d76;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  min-height: 44px;
}

.retry-btn:active {
  opacity: 0.9;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
/* AI-Generated End */
</style>
